import { getRouteObjectList, withLayout } from '../router/util/router.helper'
import { RouterLayout } from '../router/component/layout/RouterLayout'
import { controlPanelds } from '../router/model/RouteId'

export const ControlPanelRoutes = [
  withLayout(
    {
      layout: <RouterLayout />,
      routes: getRouteObjectList(controlPanelds),
    },
  ),
]
